export enum IconBlockVariant {
  DEFAULT = 'default',
  SUCCESS = 'success',
  CAUTION = 'caution',
  ERROR = 'error',
}

// from https://bobbyhadz.com/blog/typescript-convert-enum-to-union
export type IconBlockVariants = `${IconBlockVariant}`;
